import React from "react"
import { ExplorerToolsMenu } from "@/features/Explorer/ExplorerToolsMenu.tsx";
import { FlexBox } from "@/common/components/Box/FlexBox.tsx";

const ExplorerTools: React.FC = () => {
  return (
    <FlexBox
      sx={{
        top: 7,
        right: 13,
        position: "absolute",
        zIndex: 1,
      }}
    >
      <ExplorerToolsMenu />
    </FlexBox>
  )
}

export { ExplorerTools }
